export default __webpack_public_path__ + "static/media/icons8-person-96.2434785c.svg";